window.addEventListener("load", async () => {
  const cart = await fetchCartItems();
  displayCart(cart);
  displayCartTotal(cart);
  displayShippingInformation();
  onVariantChange();
});

document.addEventListener('DOMContentLoaded', async () => {
  const textarea = document.querySelector("#cart_list");
  if (!textarea) return;

  const cart = await fetchCartItems();

  let value = "🛒 BESTELLANFRAGE\n\n";

  for (let item of cart.items) {
    value += `• ${item.quantity}× ${item.title}\n`;
    value += `  Preis: ${formatMoney(item.final_line_price)}\n\n`;
  }

  value += `----------------------\n`;
  value += `Gesamt: ${formatMoney(cart.total_price)}\n`;
  value += `(inkl. 8.1% MWST)\n`;

  textarea.value = value;
});


async function clearCart() {
  await fetch('/cart/clear.js', { 
    method: 'POST', 
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin'
  });
}



async function fetchCartItems() {
  const response = await fetch('/cart.js');
  const cart = await response.json();
  return cart;
}

function displayCart(cart) {
    const warenkorbCheckout = document.getElementById("warenkorb-checkout");

    for (let item of cart.items) {
        const div = document.createElement("div");
        let selectedVariants = ``;
        for (let options of item.options_with_values) {
            if (options.value != "Default Title") {
                selectedVariants += `<small><b>${options.name}:</b> ${options.value}</small>`;
            }
        }

        let price = formatMoney(item.final_line_price);

        if (Object.keys(item.properties).length != 0) {
          price = "<em>(Der Preis wird nach Überprüfung der Anfrage ermittelt und Dir mit der Offerte mitgeteilt.)</em>";
        }
    
        div.innerHTML = `<span class="image">
        <img src="${item.image}" alt="">
        <small class="amount">${item.quantity}</small>
        </span>
        <span>
        <strong>${item.product_title}</strong>
        ${selectedVariants}
        </span>
        <script>console.log(${selectedVariants})</script>
        <span class="line-price">
        <p>${price}</p>
        </span>
        `;
        warenkorbCheckout.append(div);
    }

}
function displayCartTotal(cart) {
    const warenkorbCheckout = document.getElementById("warenkorb-total");
        const div = document.createElement("div");
        div.innerHTML = `
        <span class="subtotal-price">
        <p>Zwischensumme:</p>
        <p>${formatMoney(cart.items_subtotal_price)}</p>
        </span>
        <span class="delivery">
        <p>Versand:</p>
        <p>Wird nach der Bestellanfrage berechnet</p>
        </span>
        <span class="total-price">
        <p><strong>Gesamt:</strong></p>
        <p><strong>${formatMoney(cart.total_price)}</strong><small>(inkl. 8.1% MWST)</small></p>
        </span>
        `;
        warenkorbCheckout.append(div);

}
function displayShippingInformation() {
    const warenkorbCheckout = document.getElementById("warenkorb-total");
        const div = document.createElement("div");
        div.innerHTML = `
        <div class="shipping-information">
          <small><strong>Bitte beachte:</strong> Die Versandkosten sind in den Preisen nicht inbegriffen. Sperrige Produkte wie Holzpfähle, Bleche, Gitter, usw. können nur mit externer Spedition ausgeliefert werden. Die Versandkosten dafür bewegen sich häufig zwischen CHF 100.00 und CHF 250.00.</small>
        </div>
        `;
        warenkorbCheckout.append(div);

}

function formatMoney(cents, locale = "de-CH", currency = "CHF") {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2
  }).format(cents / 100);
}

function onVariantChange() {
  
}